<script lang="ts" setup>
import type { CSSProperties } from 'vue';

import type { Product } from '~/models';

import ProductItem from './ProductItem.vue';

const props = defineProps<{
  active: Product | null;
  products: Product[];
  isMobile?: boolean;
}>();

const emits = defineEmits<{
  (e: 'update:active', product: Product): void;
}>();

const style = computed<CSSProperties | undefined>(() => {
  if (!props.isMobile) {
    return;
  }

  return {
    backgroundImage: 'linear-gradient(to top, var(--bg-color-50), var(--bg-color-50)), var(--bg-image)',
    backgroundColor: 'var(--bg-color)',
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover',
    overflowY: 'auto',
    minHeight: 'inherit'
  };
});

const onProductClick = (product: Product): void => {
  emits('update:active', product);
};
</script>

<template>
  <div
    class="product-list flex flex-col overflow-auto"
    :class="{ 'h-dvh': props.isMobile }"
  >
    <slot name="header" />

    <div
      class="product-list__container flex-1"
      :style="style"
      data-test="container"
    >
      <slot name="caption" />

      <ul class="relative overflow-hidden py-2 flex flex-col gap-2">
        <slot />

        <ProductItem
          v-for="product of props.products"
          :key="product.uuid"
          :product="product"
          :class="{ 'mx-2': props.isMobile }"
          @click="onProductClick(product)"
        />
      </ul>
    </div>
  </div>
</template>
